import { create } from "zustand";

export const useTrainingStore = create((set) => ({
  // State
  trainings: [],
  loading: false,
  error: null,
  selectedTraining: null,
  searchQuery: "",
  filters: {},

  // Table features
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 1,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  // Modal / UI states
  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  isPersonnelStatusModalOpen: false,
  isAssignResultsModalOpen: false,
  isEvaluationsModalOpen: false,
  isEvaluationResultsModalOpen: false,
  /** Unified legacy TEF / trainer board (replaces separate modals) */
  isLegacyEvalBoardOpen: false,
  legacyEvalBoardTab: "participant",
  isDetailDialogOpen: false,
  trainingToView: null,
  trainingToDelete: null,

  userAssignments: [],

  // Basic Setters
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  setTrainings: (trainings) => set({ trainings }),
  setSelectedTraining: (training) => set({ selectedTraining: training }),
  setUserAssignments: (userAssignments) => set({ userAssignments }),

  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setFilters: (filters) => set({ filters }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setPaginationData: (data) => set((state) => ({
    paginationData: {
      ...state.paginationData,
      ...data,
      currentPage: data.page ?? data.currentPage ?? state.paginationData.currentPage,
      itemsPerPage: data.pageSize ?? data.itemsPerPage ?? state.paginationData.itemsPerPage,
      totalItems: data.total ?? data.totalItems ?? state.paginationData.totalItems,
      totalPages: data.totalPages ?? state.paginationData.totalPages,
    }
  })),

  // UI Flow Actions
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    selectedTraining: null,
    error: null
  }),

  openEditForm: (training) => set({
    isFormOpen: true,
    isEditMode: true,
    selectedTraining: training,
    error: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    selectedTraining: null,
    error: null
  }),

  openDeleteDialog: (training) => set({
    isDeleteDialogOpen: true,
    trainingToDelete: training,
    error: null
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    trainingToDelete: null,
    error: null
  }),
  


  setActiveTraining: (training) => set({ selectedTraining: training }),

  openPersonnelStatusModal: (training) => set({
    isPersonnelStatusModalOpen: true,
    selectedTraining: training
  }),

  closePersonnelStatusModal: () => set({
    isPersonnelStatusModalOpen: false,
    selectedTraining: null
  }),

  openAssignResultsModal: (training) => set({
    isAssignResultsModalOpen: true,
    selectedTraining: training
  }),

  closeAssignResultsModal: () => set({
    isAssignResultsModalOpen: false,
    selectedTraining: null
  }),

  openEvaluationsModal: (training) => set({
    isLegacyEvalBoardOpen: true,
    legacyEvalBoardTab: "participant",
    isEvaluationsModalOpen: true,
    selectedTraining: training
  }),

  closeEvaluationsModal: () => set({
    isLegacyEvalBoardOpen: false,
    isEvaluationsModalOpen: false,
    selectedTraining: null
  }),

  openEvaluationResultsModal: (training) => set({
    isLegacyEvalBoardOpen: true,
    legacyEvalBoardTab: "trainer",
    isEvaluationResultsModalOpen: true,
    selectedTraining: training
  }),

  closeEvaluationResultsModal: () => set({
    isLegacyEvalBoardOpen: false,
    isEvaluationResultsModalOpen: false,
    selectedTraining: null
  }),

  closeLegacyEvalBoard: () => set({
    isLegacyEvalBoardOpen: false,
    isEvaluationsModalOpen: false,
    isEvaluationResultsModalOpen: false,
    selectedTraining: null
  }),

  openDetailDialog: (training) => set({
    isDetailDialogOpen: true,
    trainingToView: training,
    error: null
  }),

  closeDetailDialog: () => set({
    isDetailDialogOpen: false,
    trainingToView: null,
    error: null
  }),
}));
